import { BadgeProps } from "shared/components/Spor";

// When spor supports semantics this can be deleted

/**
 * Every semantic value used across the app for Badge/Button colouring.
 */
export type SemanticValue =
  | "alarm"
  | "secondaryAlarm"
  | "warning"
  | "info"
  | "success"
  | "neutral"
  | "special"
  | "system"
  | "transparent"
  | "transparentInverted"
  | "ghost";

export type BadgeColorPalette = NonNullable<BadgeProps["colorPalette"]>;

/**
 * Spor 13.7 removed the old semantic recipe variant, so this is the
 * explicit replacement used when migrating Badge.
 */
export const semanticToColorPalette = (
  semantic: SemanticValue,
): BadgeColorPalette => {
  switch (semantic) {
    case "alarm":
      return "red";
    case "secondaryAlarm":
      return "orange";
    case "warning":
      return "yellow";
    case "info":
      return "blue";
    case "success":
      return "green";
    case "ghost":
      return "grey";
    case "neutral":
    case "special":
    case "system":
    case "transparent":
    case "transparentInverted":
      return "neutral";
  }
};
